import {
  Authors,
  RenderBody,
  Tag,
  NewsletterRelated,
  StoryHeader,
} from "@/templates/Clarin/Nota/components";
import { BannerCollapse, BannerSmallContent } from "@/shared/ContentBanner";
import RightColumn from "@/shared/RightColumn/index.jsx";
import SocialNetworking from "@/shared/SocialNetworking";
import { sizeBanner } from "@/shared/DFP/News/mapping";
import BannerLazy from "@/widgets/Banner/Templates/BannerLazy";
import Viafoura from "@/shared/Viafoura";
import { RecipeNewsContainer, StoryContentLeft, StoryContentRight, StoryBody, StoryGrid, DataStory, ListLatestSection } from "./style";
import { StoryHeaderContainer } from "@/templates/Clarin/Nota/components/StoryHeader/style";
import FormattedDate from "@/shared/FormattedDate";
import { useContext, useEffect, useState } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import OnexOneRecipe from "@/widgets/Nota/Templates/OnexOneRecipe";
import Separator from "@/shared/Separator";
import ToolBarRecipes from "@/shared/ToolBarRecipes";
import { GridStyleColor } from "@/widgets/Container/Templates/stylesGridGeneric";
import Banner from "@/widgets/Banner/Templates/Banner";

export const StoryContainer = () => {
  const dataContext = useContext(TemplateContext);
  const { storyContainer } = dataContext?.content || {};

  const {
    _id,
    authors,
    onClickButtonSlider,
    canHaveComments,
    dataImage,
    dataVideo,
    freeHtml,
    hasRelated,
    innerWidth,
    isPreview,
    mam,
    newsSeo,
    sectionIdJWPlayerLead,
    summary,
    title,
    titleEnable = true,
    payWallAccessControl,
    adsPath,
    latestSection,
    titleLatestSection = "Más recetas",
  } = storyContainer?.data;

  const [mtHeight, setMtHeight] = useState(0);

  useEffect(() => {
    const mtElement = document.getElementById("mt");
    if (mtElement) {
      setMtHeight(mtElement.offsetHeight);
      console.log("Altura del div:", mtElement.offsetHeight);
    }
  }, []);

  return (
    <>
      <RecipeNewsContainer className="NewsContainer">
        <StoryGrid mtHeight={mtHeight}>
          <StoryContentLeft mtHeight={mtHeight}>
            <StoryHeaderContainer className={`recipeHeader ${!hasRelated && "noRelated"}`}>
              <StoryHeader
                {...{
                  dataImage,
                  dataVideo,
                  freeHtml,
                  hasRelated,
                  mam,
                  onClickButtonSlider,
                  payWallAccessControl,
                  sectionIdJWPlayerLead,
                  title,
                  titleEnable,
                  summary,
                  newsSeo,
                  preloadImg: true,
                }}
              />
            </StoryHeaderContainer>
            <StoryBody id="storyBody">
              <ToolBarRecipes buttonId="reviewUp" />
              <DataStory className="dataStory">
                <div
                  className={`list-authors ${authors ? "has-border-top" : ""}`}
                >
                  <Authors />
                </div>
                <div className="place-social-mobile">
                  <SocialNetworking />
                </div>
              </DataStory>
              <FormattedDate />

              <div className="StoryTextContainer vsmcontent">
                <div id="cuerpo">
                  <RenderBody />
                </div>
              </div>
              <ToolBarRecipes buttonId="reviewDown" />
              <div id="comentarios" data-size="2"></div>

              {innerWidth <= 1023 && (
                <>
                  <BannerSmallContent key="caja1">
                    <BannerLazy isPreview={isPreview} slotId="caja1" adsPath={adsPath} mapping={sizeBanner.caja1} />
                  </BannerSmallContent>

                  <BannerSmallContent key="caja2">
                    <BannerLazy isPreview={isPreview} slotId="caja2" adsPath={adsPath} mapping={sizeBanner.caja2} />
                  </BannerSmallContent>

                  <BannerSmallContent key="caja0">
                    <Banner isPreview={isPreview} slotId="caja0" />
                  </BannerSmallContent>

                  <BannerCollapse key="caja3">
                    <BannerLazy isPreview={isPreview} slotId="caja3" adsPath={adsPath} mapping={sizeBanner.caja3} />
                  </BannerCollapse>
                </>
              )}
              <NewsletterRelated />
              <Tag />
              <div className="comments">
                {canHaveComments && <Viafoura idNews={_id} />}
              </div>
            </StoryBody>
          </StoryContentLeft>
          <StoryContentRight>{innerWidth > 1023 && <RightColumn />}</StoryContentRight>
        </StoryGrid >
        <Separator className="latest-separator" title={titleLatestSection} />
        {latestSection.length > 0 && (
          <GridStyleColor>
            <ListLatestSection>
              {latestSection.map((item, index) => (
                <OnexOneRecipe key={index} {...{ ...item, isPreview: false, images: item?.related?.images?.[0]?.clippings ?? [] }} />
              ))}
            </ListLatestSection>
          </GridStyleColor>

        )}
      </RecipeNewsContainer >
    </>
  );
};
